var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "query-list" },
    [
      _vm.selectedItems.length
        ? _c("div", { staticClass: "training-bar" }, [
            _c(
              "section",
              { staticClass: "uncheck", on: { click: _vm.unselectAll } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" arrow_back "),
                ]),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "select", on: { click: _vm.selectAll } },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
            ),
            _vm._v(" "),
            _c("section", { staticClass: "queries" }, [
              _vm._v(
                "+" +
                  _vm._s(_vm.selectedItems.length) +
                  " " +
                  _vm._s(_vm.$t("chatbotv2.queriesSelected"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "actions" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    attrs: { content: "AiTrain" },
                    on: {
                      click: function ($event) {
                        _vm.aiFaqModalVisible = true
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" smart_toy "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      visible: _vm.trainFormVisible,
                      overlayClassName: "no-padding",
                      placement: "bottom",
                      trigger: "click",
                    },
                    on: {
                      visibleChange: function (isVisible) {
                        return (_vm.trainFormVisible = isVisible)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("TrainForm", {
                          attrs: {
                            "all-stories": _vm.stories,
                            "on-cancel": function () {
                              return (_vm.trainFormVisible = false)
                            },
                            "on-train": _vm.startMultiTrain,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        attrs: { content: "Train" },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" done "),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    attrs: { content: "Ignore" },
                    on: { click: _vm.ignoreMultiRow },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" visibility_off "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    attrs: { content: "Delete" },
                    on: { click: _vm.deleteMultiRow },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" close "),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row-header" }, [
        _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.userQuery")))]),
        _vm._v(" "),
        _c("div", { attrs: { "data-sort": "" } }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("chatbotv2.date")) +
              "\n            "
          ),
          _c("span", { staticClass: "material-icons" }, [
            _vm._v(" arrow_drop_down "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { "data-sort": "" } }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("chatbotv2.unmatched")) +
              "\n            "
          ),
          _c("span", { staticClass: "material-icons" }, [
            _vm._v(" arrow_drop_down "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rows" },
        [
          _vm._l(_vm.rows, function (row) {
            return _c("QueryRowItem", {
              key: row.id,
              attrs: {
                row: row,
                "is-selected": _vm.isSelected(row),
                "on-select-changed": _vm.onSelectChanged,
                "multi-select-mode": _vm.selectedItems.length > 0,
                "on-deleted": _vm.deleteSingleRow,
                "on-ignored": _vm.ignoreSingleRow,
                "on-trained": _vm.trainSingleRow,
                stories: _vm.stories,
              },
              on: {
                trained: function ($event) {
                  _vm.isTrained = true
                },
              },
            })
          }),
          _vm._v(" "),
          _c("a-modal", { attrs: { visible: _vm.isModalShow } }, [
            _c("p", [_vm._v("Some contents...")]),
            _vm._v(" "),
            _c("p", [_vm._v("Some contents...")]),
            _vm._v(" "),
            _c("p", [_vm._v("Some contents...")]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.aiFaqModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                className: "ai-destroy-modal",
                showFooter: false,
                showTitle: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.aiFaqModalVisible = false
                },
              },
            },
            [
              _c("AIKnowledgeCreateForm", {
                attrs: {
                  title: "Question",
                  description: "Answer",
                  "question-item": _vm.matchedItems,
                },
                on: { faqCreated: _vm.faqCreated },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }